import { AxiosResponse } from 'axios';
import { NotificaRes } from 'civil-status/model/notifications';
import { NotificationsList } from 'civil-status/view-models/notifications-list';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';

export const transformNotificationsList = (
  response: AxiosResponse<HttpResponse<NotificaRes>>
): Array<NotificationsList> => {
  const dataRes = response.data.payload.notifiche || [];
  const datiPaginazione = response.data.payload.datiPaginazione || {};

  return dataRes.map((item) => ({
    totalCount: datiPaginazione.numRecordTotali || 0,
    id: item.notifica?.id || '',
    date: item.notifica?.dataInizioValidita
      ? DateTime.fromISO(item.notifica?.dataInizioValidita).toFormat('dd/MM/yyyy')
      : '',
    description: item.notifica?.descrizione || '',
    idAnsc: item.notifica?.idAnsc || '',
    stateCode: item.notifica?.idStatoFlussoNotifiche || '',
    typeContent: item.eventoCollegato?.idtipocontenuto || '',
    typeEvent: item.eventoCollegato?.idTipoEvento || '',
    municipalityFormation: item.nomeComuneFormazione || '',
    municipalityCompetent: item.nomeComuneCompetente || '',
    holders: item.notifica?.descsoggettointestatario
      ? item.notifica?.descsoggettointestatario
      : `${item.soggettoRif?.nome || ''} ${item.soggettoRif?.cognome || ''}`,
  }));
};
